import { useDrag } from 'react-dnd';

import { dragItemTypes } from '../../../constants/myCampaigns.js';
import {
  ChannelPlatformRow,
  Props as RowProps,
} from './ChannelPlatformRow.jsx';

export const DragItemRow = ({ type, row, inverted, ...opts }: RowProps) => {
  const [{ isDragging }, drag] = useDrag({
    type: type || dragItemTypes.ADD_ROW,
    item: {
      ...row,
      options: { ...opts, inverted },
      type: type || dragItemTypes.ADD_ROW,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: () => !inverted,
  });

  return (
    <ChannelPlatformRow
      // @ts-expect-error wrong type in library
      ref={drag}
      row={row}
      {...opts}
      inverted={isDragging || inverted}
    />
  );
};
